
import {mapActions, mapState} from "vuex";
import GlobalStore from "@/store/modules/global";
import {throwError} from "rxjs";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import VueRecaptcha from "vue-recaptcha";
import {router} from "@/router";
import SolicitacaoService from "@/services/sie-pedidos/solicitacao.service";

const actions = mapActions('siePedidos', ['setFormStep']);
const actionsAluno = mapActions('siePedidos', ['setShowModalSolicitacaoAluno']);
const state = mapState("global", ['user']);
export default {
  name: "FormConsultaCPF",
  components: {VueRecaptcha},
  computed: {
    ...state
  },
  data() {
    return{
      siteKey: VUE_APP_RECAPTCHA_KEY,
      form: {
        cpf: null,
        dataNascimento: null,
        isLoading: false,
        recaptcha: null,
      },
      rules: {
        required: (value) => !!value || "Esse campo deve ser preenchido",
      },
    }
  },
  methods: {
    ...actions,
    ...actionsAluno,
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    formatDate(data){
      const partesData = data.split('/');
      const dia = partesData[0];
      const mes = partesData[1];
      const ano = partesData[2];
      return `${ano}-${mes}-${dia}`
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        SolicitacaoService.getStatusAlunoSolicitacao({
          cpf: this.form.cpf.replaceAll(/[^a-zA-Z0-9]/g, ""),
          dataNascimento: this.formatDate(this.form.dataNascimento)
        }).subscribe(
          response => {
            const resp = response['result']
            if (resp && resp?.cpf) {
              this.setShowModalSolicitacaoAluno(resp)
              router.push("/carteira-macrorregiao/aluno/aluno-solicitacao")
            } else {
              GlobalStore.setSnackBar({
                show: !!response['message'],
                message: "" + response['message'],
                type: 'error'
              })
            }
          },
          error => {
            throwError(error);
            this.loading = false;
          }
        )
      }
    }
  }
}
